import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '快捷导航',
    links: [
      { label: '首页', path: '/' },
      { label: '电影分类', path: '/category/dongzuo' },
      { label: '最新上线', path: '/category/zuixin' },
      { label: '高分推荐', path: '/category/gaofen' },
    ],
  },
  categories: {
    title: '电影类型',
    links: [
      { label: '动作片', path: '/category/dongzuo' },
      { label: '喜剧片', path: '/category/xiju' },
      { label: '爱情片', path: '/category/aiqing' },
      { label: '科幻片', path: '/category/kehuan' },
      { label: '恐怖片', path: '/category/kongbu' },
      { label: '动画片', path: '/category/donghua' },
      { label: '电视剧', path: '/category/dianshiju' },
      { label: '综艺', path: '/category/zongyi' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '用户口碑', path: '/about#reviews' },
      { label: '影视资讯', path: '/article/1' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-accent-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-white">爱丫爱丫影院</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6">
              高清电影免费在线观看平台。流畅播放，秒开看剧，无广告不缓冲，极速观影体验。每日更新，海量资源，不卡顿影院。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          {[footerLinks.product, footerLinks.categories, footerLinks.about].map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a className="cursor-pointer">{section.title}</a>
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 爱丫爱丫影院 版权所有 | 高清电影免费在线观看
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="#" className="hover:text-foreground-200 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-foreground-200 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="hover:text-foreground-200 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}